module.exports = {
      id: "gallery-scope-usage",
      viewBox: "0 0 32 32",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#gallery-scope",
      toString: function () {
        return this.url;
      }
    }